export const getExtension = (path: string, collectBNA?: number) => {
  const parts = path.split('.');
  if (collectBNA && collectBNA === 4) {
    return 'bnacollect';
  }
  return parts[parts.length - 1];
};
